import { useMemo } from "react";

export function useLoginMode() {
  return useMemo(() => {
    try {
      const value = localStorage.getItem("loginMode");
      return value === "customer" ? value : "customer";
    } catch {
      return "customer";
    }
  }, []);
}
